import { render } from "./ZsctWordRight.vue?vue&type=template&id=14fa5206"
import script from "./ZsctWordRight.vue?vue&type=script&lang=js"
export * from "./ZsctWordRight.vue?vue&type=script&lang=js"

import "./ZsctWordRight.vue?vue&type=style&index=0&id=14fa5206&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__